<template>
    <Teleport to="body">
        <Transition name="modal-fade">
            <div
                v-if="isVisible"
                class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px]"
                @click.self="closeModal"
            >
                <div
                    class="w-full max-w-lg md:max-w-2xl max-h-[90vh] bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-100 overflow-hidden flex flex-col"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="payment-history-title"
                >
                    <div class="flex items-start justify-between px-6 pt-6 pb-4 border-b border-gray-100 shrink-0">
                        <div class="flex-1 pr-4">
                            <h2 id="payment-history-title" class="text-lg font-semibold text-gray-900">
                                История платежей
                            </h2>
                            <p class="text-sm text-gray-500 mt-1">
                                Все операции по подписке и оплате сервиса
                            </p>
                        </div>

                        <button
                            type="button"
                            class="flex items-center justify-center w-8 h-8 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                            aria-label="Закрыть"
                            @click="closeModal"
                        >
                            <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>

                    <div class="px-6 py-5 overflow-y-auto">
                        <div v-if="transactions.length" class="space-y-3">
                            <div
                                v-for="tx in transactions"
                                :key="tx.id"
                                class="rounded-xl border border-gray-100 bg-gray-50/50 p-4"
                            >
                                <div class="flex items-start justify-between gap-4">
                                    <div class="min-w-0">
                                        <div class="flex items-center gap-2 flex-wrap">
                                            <p class="text-sm font-semibold text-gray-900">
                                                {{ tx.description || 'Оплата подписки' }}
                                            </p>
                                            <StatusBadge :status="tx.status" />
                                        </div>
                                        <p class="text-sm text-gray-500 mt-1">{{ tx.date }}</p>
                                    </div>
                                    <p class="text-base font-semibold text-gray-900 shrink-0">
                                        {{ tx.amount }}
                                    </p>
                                </div>

                                <div class="mt-3 pt-3 border-t border-gray-100 grid grid-cols-1 sm:grid-cols-2 gap-2">
                                    <div>
                                        <p class="text-xs text-gray-500">Способ оплаты</p>
                                        <p class="text-sm text-gray-800">{{ tx.paymentMethod || '—' }}</p>
                                    </div>
                                    <div>
                                        <p class="text-xs text-gray-500">Номер заказа</p>
                                        <p class="text-sm text-gray-800">{{ tx.orderId || '—' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            v-else
                            class="rounded-xl border border-dashed border-gray-200 bg-gray-50 px-4 py-10 text-center"
                        >
                            <p class="text-sm font-medium text-gray-700">Платежей пока нет</p>
                            <p class="text-sm text-gray-500 mt-1">
                                Здесь появится история оплат после первого платежа
                            </p>
                        </div>
                    </div>

                    <div class="flex items-center justify-end px-6 py-4 bg-gray-50 border-t border-gray-100 shrink-0">
                        <button
                            type="button"
                            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                            @click="closeModal"
                        >
                            Закрыть
                        </button>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
import { defineModel, defineProps } from 'vue';
import StatusBadge from "@/pages/UserProfile/components/StatusBadge.vue";

defineProps({
    transactions: {
        type: Array,
        default: () => []
    }
});

const isVisible = defineModel();

function closeModal() {
    isVisible.value = false;
}
</script>

<style scoped>
.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;
}
</style>
